<template>
    <div class="traveller-item" :class="{ active: isSelectedTraveller }" @click="selectTraveller">
        <div
            class="seat"
            :class="{
                active: selectedSeat,
                'not-chosen': !selectedSeat,
            }"
        >
            {{ selectedSeat ?? '?' }}
        </div>

        <div class="content">
            <div class="name">{{ props.firstName }} {{ props.lastName }}</div>

            <span class="note" v-if="selectedSeat">
                Sedadlo {{ selectedSeat }}
                <button type="button" class="btn-link text-primary" @click="deselectSeat(selectedSeat, hash)">Zrušiť</button>
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>

import { computed } from 'vue';
import { useSeatReservation } from '../../modules/useSeatReservation';

interface Props {
    firstName: string;
    lastName: string;
    hash: string;
}

const props = defineProps<Props>();

const { seatReservationState, deselectSeat } = useSeatReservation();

const isSelectedTraveller = computed(() => seatReservationState.selectedTraveller === props.hash);

const selectedSeat = computed(() => seatReservationState.allSeats.find((seat) => seat.traveller_hash === props.hash)?.seat_number as number);

const selectTraveller = () => {
    seatReservationState.selectedTraveller = props.hash;
};

</script>
